<template>
  <v-form @submit.prevent="linkProjectsToUser" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>

      <v-layout row wrap>
        <v-flex xs12 md12>
          <v-autocomplete
            :items="users"
            :filter="filterUsers"
            item-text="name"
            item-value="id"
            hint="Selecionar usuário"
            v-model="user"
            required
            return-object
            persistent-hint
            clearable
            :disabled="(users.length === 0 || disabledUserSelect())"
            no-data-text="Nenhuma registro encontrado"
            placeholder="Selecione um usuário para prosseguir"
            :error-messages="validationErrors.user"></v-autocomplete>
        </v-flex>

        <v-flex xs12 md12>
          <v-select
            :items="projects"
            item-text="name"
            item-value="id"
            hint="Vincular projetos ao usuário selecionado"
            v-model="projectsSelected"
            required
            return-object
            persistent-hint
            clearable
            multiple
            chips
            :disabled="(projects.length === 0 || !user)"
            no-data-text="Nenhuma registro encontrado"
            placeholder="Selecione um projeto"
            :error-messages="validationErrors.projectsSelected">

            <template slot="prepend-item">
              <v-list-tile
                ripple
                @click="toggle"
              >
                <v-list-tile-action>
                  <v-icon :color="projectsSelected.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Selecionar Todos</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>

          </v-select>
        </v-flex>
      </v-layout>

      <v-alert
        :value="showAlert"
        type="error">
        Não existem projetos cadastrados no sistema.
      </v-alert>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :disabled="(projects.length === 0)" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ProjectService from '@/features/project/ProjectService';
import UserService from '@/features/user/UserService';

export default {
  name: 'project-form',
  mixins: [CrudMixin],
  computed: {
    likesAllProjects() {
      return this.projectsSelected.length === this.projects.length;
    },
    likesSomeProjects() {
      return this.projectsSelected.length > 0 && !this.likesAllProjects;
    },
    icon() {
      if (this.likesAllProjects) return 'close';
      if (this.likesSomeProjects) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
  },
  watch: {
    user() {
      if (this.user) {
        this.fetchProjects();
      }
    },
  },
  data() {
    return {
      loadingUsers: false,
      searchUsers: null,
      showAlert: false,
      projects: [],
      users: [],
      user: null,
      projectsSelected: [],
      projectService: new ProjectService(),
      currentUser: this.$store.state.currentUser,
    };
  },
  beforeMount() {
    this.fetchUsers();
    this.user = this.users.find(item => item.id === this.getId());
  },
  methods: {
    initCrud() {
      this.serviceType = UserService;
      this.routerName = 'user-project';
      this.componentType = 'FORM';
      this.onSearchInit = false;
    },
    filterUsers(item, queryText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.email.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1;
    },
    async fetchProjects() {
      const params = {};
      if (!UserService.hasProfile(this.currentUser, ['master', 'admin', 'analista'])) {
        params.client_id = this.user.client_id;
      }

      this.projects = await this.projectService.query(params);

      if (this.projects.length === 0) {
        this.showAlert = true;
      }
    },
    async fetchUsers() {
      this.users = await this.service.query();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllProjects) {
          this.projectsSelected = [];
        } else {
          this.projectsSelected = this.projects.slice();
        }
      });
    },
    async linkProjectsToUser() {
      const response = await this.service.request(
        'POST',
        'sync-to-projects',
        {
          id: this.user.id,
          projectIds: this.projectsSelected.map(item => item.id),
        },
      );
      this.$toast.success(response.data);
      this.goToList();
    },
    disabledUserSelect() {
      const id = this.getId();
      return (id !== 'new');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/user-project/UserProjectForm.vue